/* eslint-disable max-len */
import { LOCALES } from 'i18n/locales';

export const homePageIntl = {
    [LOCALES.ENGLISH]: {
        'homePage.title': 'Welcome to the National Underground Asset Register',
        'homePageAlert.title': 'Important',
        'homePageAlert.button': 'Permitted use under the End User Terms',
        'signin.title': 'Sign in to NUAR',
        'signin.button': 'Sign in',
        'signin.description': 'NUAR is currently available to Utility and Infrastructure Asset Owners, Statutory Undertakers, and Statutory Authorities. To gain access, please register through your organisation’s designated NUAR Champion. If you\'re unsure who this is, contact <mailto>support@nuar.uk</mailto>  for assistance.',
        'signin.description2': 'Once registered with the relevant Asset Owner, you can sign in to the NUAR platform. Contractors must register via the Asset Owners they are working on behalf of.'
    },
    [LOCALES.WELSH]: {
        'homePage.title': 'Croeso i\'r Gofrestr Asedau Tanddaearol Cenedlaethol (NUAR)',
        'homePageAlert.title': 'Pwysig',
        'homePageAlert.button': '[Permitted use under the End User Terms]',
        'signin.title': 'Mewngofnodi i NUAR',
        'signin.button': 'Mewngofnodi',
        'signin.description': '[NUAR is currently available to Utility and Infrastructure Asset Owners, Statutory Undertakers, and Statutory Authorities. To gain access, please register through your organisation’s designated NUAR Champion. If you\'re unsure who this is, contact support@nuar.uk  for assistance.]',
        'signin.description2': '[Once registered with the relevant Asset Owner, you can sign in to the NUAR platform. Contractors must register via the Asset Owners they are working on behalf of.]'
    }
};
